export const entitiesPtBr = {
  title: 'Entidades',
  subtitle: 'Empresas da conta',
  loading: 'Carregando entidades...',
  noResults: 'Nenhuma entidade encontrada.',
  createButton: 'Nova entidade',
  searchPlaceholder: 'Buscar entidades…',
  form: {
    create: 'Nova entidade',
    edit: 'Editar Entidade',
    // Next to Salvar while it is disabled: the labels of the fields still to be filled, joined.
    missingFields: 'Falta preencher: {{fields}}',
    basicInfo: {
      title: 'Informações Básicas',
      description: 'Dados cadastrais da empresa',
      country: 'País de domicílio',
      countryPlaceholder: 'Selecione o país',
      identifierLabels: {
        CNPJ: 'CNPJ',
        RFC: 'RFC',
        EIN: 'EIN',
        VAT: 'Identificação de IVA/VAT',
      },
      identifierPlaceholders: {
        CNPJ: '00.000.000/0000-00',
        RFC: 'AAA000000AAA',
        EIN: '00-0000000',
        VAT: 'Identificador fiscal nacional',
      },
      correctionReason: 'Motivo da correção',
      correctionReasonPlaceholder: 'Informe a fonte documental da correção',
      name: 'Nome',
      namePlaceholder: 'Nome da empresa',
      legalName: 'Razão social',
      optional: 'opcional',
      lockedAtCreation: 'Definido na criação',
      tradeName: 'Nome fantasia',
      tradeNamePlaceholder: 'Nome fantasia',
      cnpj: 'CNPJ',
      cnpjPlaceholder: '00.000.000/0000-00',
      stateRegistration: 'Inscrição estadual',
      stateRegistrationPlaceholder: 'Isento ou número da IE',
      municipalRegistration: 'Inscrição municipal',
      municipalRegistrationPlaceholder: 'Número da IM',
      addressStreet: 'Logradouro',
      addressStreetPlaceholder: 'Rua Exemplo',
      addressNumber: 'Número',
      addressNumberPlaceholder: '100',
      addressDistrict: 'Bairro',
      addressDistrictPlaceholder: 'Centro',
      addressCity: 'Cidade',
      addressCityPlaceholder: 'São Paulo',
      addressState: 'UF',
      addressStatePlaceholder: 'SP',
      addressPostalCode: 'CEP',
      addressPostalCodePlaceholder: '00000-000',
      addressCodigoMunicipio: 'Código município (IBGE)',
      addressCodigoMunicipioPlaceholder: '0000000',
      addressCodigoMunicipioSearch: 'Buscar o município',
      addressCodigoIbgeCepHint: 'Preencha CEP para buscar',
      addressCodigoUf: 'Código UF (IBGE)',
      addressCodigoUfPlaceholder: '00',
      groups: {
        identification: {
          title: 'Identificação',
          subtitle: 'Quem é a empresa: país de domicílio, documento e nomes.',
        },
        registrations: {
          title: 'Inscrições',
          subtitle: 'Inscrições fiscais e códigos IBGE do município e da UF.',
        },
        address: {
          title: 'Endereço',
          subtitle: 'Onde a empresa está estabelecida.',
        },
      },
      serpro: {
        loading: 'Consultando SERPRO...',
        genericError: 'Erro ao consultar SERPRO',
        invalidCnpj: 'CNPJ inválido',
        notFound: 'CNPJ não encontrado na SERPRO',
      },
      focusCep: {
        autofillSuccess: 'Endereço preenchido automaticamente a partir do CEP.',
        notFound: 'CEP não encontrado.',
        lookupError: 'Erro ao consultar CEP.',
      },
    },
    taxpayerIdentity: {
      title: 'Identidade do contribuinte federal',
      description:
        'Defina a matriz ou filial pelo papel jurídico e pelo período. O número 0001 não define a matriz.',
      ownerReview:
        'Revise a raiz, o papel e a vigência com o responsável fiscal antes de concluir.',
      cnpjRoot: 'Raiz do CNPJ',
      role: 'Papel',
      rolePlaceholder: 'Escolha matriz ou filial',
      roles: { HEAD_OFFICE: 'Matriz', BRANCH: 'Filial' },
      validFrom: 'Válido desde',
      validTo: 'Válido até (opcional)',
      validFromRequired: 'Informe a data inicial da composição do contribuinte federal.',
      errors: {
        TAXPAYER_CNPJ_INVALID: 'O CNPJ informado é inválido. Confira o número e tente novamente.',
        TAXPAYER_CNPJ_ROOT_INVALID: 'A raiz do CNPJ precisa ter exatamente oito letras ou números.',
        TAXPAYER_ENTITY_NOT_FOUND:
          'Não encontramos a empresa. Atualize a página e tente novamente.',
        TAXPAYER_ENTITY_CNPJ_REQUIRED:
          'Informe o CNPJ da empresa antes de definir a matriz ou filial.',
        TAXPAYER_ENTITY_CNPJ_CONFLICT:
          'O CNPJ da empresa não confere com o identificador fiscal principal. Corrija o cadastro antes de definir a matriz ou filial.',
        TAXPAYER_NOT_FOUND:
          'Não encontramos o contribuinte federal. Atualize a página e tente novamente.',
        TAXPAYER_CNPJ_ROOT_MISMATCH: 'Matriz e filiais precisam ter a mesma raiz de CNPJ.',
        TAXPAYER_MEMBERSHIP_DATE_INVALID:
          'A data final precisa ser igual ou posterior à data inicial.',
        TAXPAYER_MEMBERSHIP_OVERLAP:
          'A empresa já pertence a um contribuinte federal nesse período.',
        TAXPAYER_MULTIPLE_HEAD_OFFICES:
          'Já existe uma matriz ativa para esse contribuinte federal no período informado.',
        TAXPAYER_SUCCESSION_SAME_DAY:
          'A substituição da matriz precisa começar depois do início da matriz atual. Informe uma data posterior.',
        TAXPAYER_HEAD_OFFICE_REQUIRED: 'Defina uma única matriz ativa para o período da apuração.',
        TAXPAYER_COMPANY_TAX_REGIME_MISMATCH:
          'Matriz e filiais precisam usar o mesmo regime tributário da empresa.',
        TAXPAYER_PIS_COFINS_REGIME_MISMATCH:
          'Matriz e filiais precisam usar o mesmo regime de PIS/COFINS.',
        TAXPAYER_APPROVED_ASSESSMENT_LOCKED:
          'Uma apuração aprovada usa essa composição. Reabra ou substitua a apuração antes de alterar matriz ou filial nesse período.',
        TAXPAYER_EXPLICIT_ROLES_REQUIRED:
          'Esta raiz de CNPJ já pertence a outra empresa ou contribuinte federal. Escolha explicitamente se o estabelecimento é matriz ou filial.',
        TAXPAYER_FISCAL_MEMBERSHIP_CHANGED_RETRY:
          'A composição de matriz e filiais mudou durante o salvamento. Atualize os dados e tente novamente.',
      },
      succession: {
        title: 'Substituir a matriz ativa?',
        description:
          'A matriz atual será encerrada nessa função na véspera e passará a ser filial na data informada. Essa alteração afeta as próximas apurações federais.',
        confirm: 'Substituir matriz',
        cancel: 'Manter matriz atual',
      },
    },
    regimeAliquotas: {
      title: 'Regime & Alíquotas',
      description: 'Configure parâmetros fiscais desta empresa.',
    },
    historicalLedger: {
      title: 'Fim do histórico importado',
      description:
        'Use esta data quando a entidade veio de outro sistema e o razão de lá já foi importado. Ela diz até quando a contabilidade já está pronta.',
      effects: {
        title: 'O que esta data faz',
        reconciled:
          'Movimentos bancários até esta data são conciliados como "Já contabilizado no histórico importado". Eles não geram contas a pagar, contas a receber nem lançamentos, porque o razão importado já os contém.',
        normalAfter: 'Movimentos depois desta data seguem o fluxo normal.',
        checks:
          'Para salvar, cada mês até a data precisa de 3 verificações em OK: razão verificado, banco = extrato (ao centavo) e mês fechado.',
        moveBack:
          'Você pode avançar a data depois. Para voltar a data, desfaça antes as conciliações "Já contabilizado no histórico importado" que ficariam fora dela.',
      },
      empty: {
        title: 'Nada a configurar nesta entidade',
        body: 'Esta entidade não tem razão importado e verificado de outro sistema. Sem isso, a data não se aplica: todos os movimentos bancários seguem o fluxo normal.',
      },
      dateLabel: 'Data de fim do histórico',
      stored: 'Data salva: {{date}}',
      notSet: 'Nenhuma data salva.',
      suggestion: 'Sugestão: {{date}} (última importação verificada).',
      useSuggestion: 'Usar sugestão',
      laterVerified: 'Há importação verificada até {{date}}. Atualize a data.',
      nativeAccrualWarning:
        '{{count}} lançamento(s) de provisão nativos de contas a pagar/receber com data até {{date}} podem duplicar o que já está no razão importado.',
      loading: 'Calculando verificações...',
      loadError: 'Não foi possível carregar as verificações.',
      noMonths: 'Nenhuma importação verificada para esta entidade.',
      save: 'Salvar',
      saveReason: {
        noDate: 'Escolha uma data para salvar.',
        notGreen: 'Salvar fica disponível quando todos os meses da tabela estiverem em OK.',
        alreadySaved: 'Esta data já está salva.',
      },
      saved: 'Data de fim do histórico salva.',
      checking: 'Verificando {{date}}...',
      manageRequired:
        'Você precisa da permissão de gerenciar a contabilidade para salvar esta data.',
      tieOutStale:
        'Há conta bancária com movimento até {{date}} que não estava na conferência salva. Salve a data de novo para incluí-la; até lá, os movimentos dela não podem ser marcados como já contabilizados.',
      openingCutoffRow: 'Saldos de abertura ({{date}})',
      failedRows: {
        title: 'O servidor recusou {{date}}. Verificações que não passaram:',
        month: 'Mês',
        account: 'Conta',
        check: 'Verificação',
        gl: 'Contábil',
        statement: 'Extrato',
        difference: 'Diferença',
      },
      checks: {
        RAZAO_VERIFIED: 'Razão verificado',
        BANK_TIE_OUT: 'Banco = extrato',
        MONTH_CLOSED: 'Mês fechado',
      },
      table: {
        month: 'Mês',
        razaoVerified: 'Razão verificado',
        bankTieOut: 'Banco = extrato',
        monthClosed: 'Mês fechado',
        account: 'Conta',
        gl: 'Contábil',
        statement: 'Extrato',
      },
      status: {
        GREEN: 'OK',
        RED: 'Pendente',
        GREY: 'Fora do escopo',
        NOT_APPLICABLE: 'Não se aplica',
      },
      reasons: {
        TIED_OUT: 'Confere',
        STATEMENT_BALANCE_MISSING: 'Sem saldo de extrato',
        AMOUNT_MISMATCH: 'Contábil diferente do extrato',
        PROOF_UNAVAILABLE: 'Prova de saldo indisponível',
        ACCOUNT_NOT_VISIBLE: 'Conta sem acesso',
        OUT_OF_SCOPE: 'Sem movimento nem saldo',
        PROOF_FAILED: 'Falha ao calcular a prova de saldo',
        FOREIGN_CURRENCY: 'Conta em moeda estrangeira',
      },
      errors: {
        ENTITY_HISTORICAL_LEDGER_END_DATE_CHECKS_FAILED:
          'Não foi possível salvar: {{count}} verificação(ões) não passaram. Corrija os meses em vermelho.',
        ENTITY_HISTORICAL_LEDGER_END_DATE_MOVE_BACK_BLOCKED:
          'Não é possível voltar ou limpar a data: {{count}} conciliação(ões) "Já contabilizado no histórico importado" ficariam fora do período. Desfaça-as primeiro.',
        ENTITY_HISTORICAL_LEDGER_END_DATE_NOT_VERIFIED_MONTH_END:
          'A data precisa ser o fim de um mês com importação verificada: {{dates}}.',
        ENTITY_HISTORICAL_LEDGER_BOOK_NOT_FOUND:
          'Esta entidade não tem livro contábil. Configure a contabilidade em Configurações → Contábil & Fiscal → Entidades → editar a entidade.',
        ENTITY_HISTORICAL_LEDGER_INVALID_DATE: 'Data inválida. Use o formato dd/mm/aaaa.',
        ENTITY_STATEMENT_BALANCE_MONTH_NOT_ENDED:
          'O mês ainda não terminou. Você poderá digitar o saldo do extrato a partir de {{date}}.',
        ENTITY_STATEMENT_BALANCE_MONTH_LOCKED:
          'Bloqueado: mês já salvo em Fim do histórico importado (até {{date}}). Antecipe a data para alterar o saldo digitado.',
        ENTITY_STATEMENT_BALANCE_PROVIDER_BALANCE_EXISTS:
          'O banco já informa um saldo desta conta no fim do mês, então o saldo digitado não é aceito.',
        ENTITY_STATEMENT_BALANCE_RECON_MONTH_CLOSED:
          'Mês fechado na conciliação: reabra para alterar o saldo digitado.',
        ENTITY_STATEMENT_BALANCE_MONTH_NOT_IN_HISTORY:
          'Este mês não faz parte do histórico importado, então o saldo do extrato não pode ser digitado aqui.',
        ENTITY_STATEMENT_BALANCE_INVALID_AMOUNT:
          'Valor inválido. Informe o saldo do extrato, por exemplo 1.525,15.',
        ENTITY_STATEMENT_BALANCE_INVALID_MONTH: 'Mês inválido.',
        generic: 'Não foi possível salvar a data de fim do histórico.',
      },
      declared: {
        inputLabel: 'Saldo do extrato de {{account}} em {{month}}',
        save: 'Salvar',
        saveFor: 'Salvar o saldo do extrato de {{account}} em {{month}}',
        clear: 'Limpar',
        clearFor: 'Limpar o saldo digitado de {{account}} em {{month}}',
        negativeFor: 'Saldo negativo de {{account}} em {{month}}',
        negativeHint: 'Sinal de menos: a conta está no vermelho',
        exactOnly:
          'Este valor tem mais casas decimais do que o campo aceita e aparece exato. Limpe para digitar outro.',
        saved: 'Saldo do extrato salvo.',
        cleared: 'Saldo digitado removido.',
        typedBy: 'Digitado por {{user}} em {{date}}',
        typedByUnknown: 'Digitado em {{date}}',
        imported: 'importado: {{amount}}',
        importedAs: {
          DAILY_BALANCE: 'importado (saldo diário): {{amount}}',
          LAST_TRANSACTION_BALANCE: 'importado (saldo da última transação): {{amount}}',
        },
        sources: {
          USER_DECLARED: 'Digitado',
          STATEMENT_CLOSING: 'Extrato importado',
          DAILY_BALANCE: 'Saldo diário',
          LAST_TRANSACTION_BALANCE: 'Último lançamento',
        },
        confirmClear: {
          title: 'Limpar o saldo digitado?',
          description:
            'O saldo digitado de {{account}} em {{month}} será removido. O mês volta a usar o saldo importado, se houver um.',
          confirm: 'Limpar',
        },
        locked: {
          MONTH_NOT_ENDED: 'Disponível a partir de {{date}}',
          BEFORE_SAVED_END_DATE: 'Bloqueado: mês já salvo em Fim do histórico importado',
          PROVIDER_BALANCE_EXISTS: 'O banco já informa o saldo deste mês',
          SUPERSEDED: 'Saldo digitado ignorado: existe saldo informado pelo banco',
          RECON_MONTH_CLOSED: 'Mês fechado na conciliação: reabra para alterar',
          MONTH_NOT_IN_HISTORY: 'Este mês não faz parte do histórico importado',
        },
      },
    },
    accounting: {
      title: 'Configuração contábil inicial',
      description: 'Cria o livro estatutário e define sua moeda funcional.',
      calendar: 'Calendário fiscal',
      calendarPlaceholder: 'Selecione um calendário',
      framework: 'Norma contábil',
      frameworkPlaceholder: 'Selecione a norma contábil',
      functionalCurrency: 'Moeda funcional',
      bookCode: 'Código do livro',
      bookName: 'Nome do livro',
      chart: 'Plano de contas',
      chartPlaceholder: 'Selecione o plano de contas',
      chartNotNeededForMemo: 'Livros fiscais (TAX_BASIS) não usam plano de contas.',
      noPublishedCharts:
        'Nenhum plano de contas publicado disponível para esta organização. Publique um plano de contas em Configurações antes de criar a entidade.',
    },
    coaSetup: {
      title: 'Plano de contas',
      description: 'Escolha como o plano de contas ativo deste livro será provisionado.',
      mode: 'Modo',
      modePlaceholder: 'Selecione um modo',
      modes: {
        CREATE_NEW: 'Criar um novo plano do zero',
        USE_EXISTING: 'Usar uma versão publicada existente',
        CLONE_EXISTING: 'Clonar a partir de uma versão existente',
      },
      loadingVersions: 'Carregando versões...',
      existingVersion: 'Versão existente',
      existingVersionPlaceholder: 'Selecione uma versão publicada',
      versionNumber: 'Número da versão',
      versionNumberPlaceholder: 'Ex.: BR-V1',
      versionName: 'Nome da versão',
      versionNamePlaceholder: 'Ex.: Plano de Contas Brasil',
      versionDescription: 'Descrição (opcional)',
      versionDescriptionPlaceholder: 'Notas sobre esta versão',
      sourceVersion: 'Versão de origem',
      sourceVersionPlaceholder: 'Selecione a versão a ser clonada',
    },
    fxPolicy: {
      title: 'Política de câmbio (FX)',
      description: 'Cria a política de câmbio deste livro com contas padrão inteligentes.',
      name: 'Nome da política',
      namePlaceholder: 'Ex.: Política de Câmbio Brasil',
      defaultsNote:
        'As contas de ganho/perda cambial não realizados serão resolvidas automaticamente a partir do plano de contas ativo.',
      deferredForNewChart:
        'Um plano de contas novo e vazio ainda não tem contas para configurar a política de câmbio. Adicione as contas necessárias e configure a política de câmbio depois, em Configurações.',
    },
  },
  page: {
    listLabel: 'Lista de entidades',
    searchLabel: 'Buscar entidades',
    empty: 'Nenhuma entidade cadastrada. Use “Nova entidade” para criar a primeira.',
    listLoadError: 'Não foi possível carregar a lista de entidades.',
    loadError: 'Não foi possível carregar a entidade.',
    loadingDetails: 'Carregando a entidade…',
    tabsLabel: 'Seções da entidade',
    tabs: {
      basic: 'Informações básicas',
      regime: 'Regime & Alíquotas',
      revenueTax: 'Tributos sobre a receita',
      history: 'Histórico',
      revenueTaxPending: 'configuração pendente',
    },
    regimeBrazilOnly: 'Regime tributário e alíquotas só se aplicam a entidades no Brasil.',
    revenueTaxBrazilOnly:
      'Tributos sobre a receita (PIS/COFINS) só se aplicam a entidades no Brasil.',
    tabReadOnly: 'Somente leitura: você não tem permissão para alterar esta seção.',
    // The save bar is hidden on this tab (the steps save themselves), so both sentences send the
    // person to the tab that has it.
    revenueTaxSaveFirst:
      'Há alterações de regime e alíquotas sem salvar. Salve na aba "{{tab}}" para atualizar os tributos sobre a receita.',
    revenueTaxSaveToActivate: 'Salve as alterações na aba "{{tab}}" para ativar.',
    footer: {
      count_one: '{{count}} entidade',
      count_other: '{{count}} entidades',
      discard: 'Descartar',
      save: 'Salvar alterações',
      allSaved: 'Tudo salvo',
      unsaved_one: '{{count}} alteração não salva',
      unsaved_other: '{{count}} alterações não salvas',
      readOnly: 'Somente leitura',
    },
    discardDialog: {
      title: 'Descartar alterações?',
      description: 'As alterações não salvas desta entidade serão perdidas.',
      confirm: 'Descartar',
      cancel: 'Continuar editando',
    },
  },
  detail: {
    entity: 'Entidade',
    tradeName: 'Nome fantasia',
    cnpj: 'CNPJ',
    group: 'Grupo',
  },
  common: {
    loading: 'Carregando...',
    save: 'Salvar',
    saving: 'Salvando…',
    retry: 'Tentar novamente',
    cancel: 'Cancelar',
    edit: 'Editar',
    back: 'Voltar',
  },
  toasts: {
    created: 'Entidade criada com sucesso.',
    updated: 'Entidade atualizada com sucesso.',
    updatedContinueRevenueTax:
      'Entidade atualizada. Continue a configuração dos tributos sobre a receita abaixo.',
    updatedContinueRevenueTaxTab: 'Entidade atualizada. Agora revise os tributos sobre a receita.',
    error: 'Erro ao salvar entidade.',
    nameRequired: 'Nome é obrigatório.',
    tradeNameRequired: 'Nome fantasia é obrigatório.',
    cnpjRequired: 'CNPJ válido é obrigatório.',
    primaryIdentifierRequired: 'Informe um identificador fiscal válido para o país selecionado.',
    accountingSetupRequired: 'Calendário, moeda e dados do livro estatutário são obrigatórios.',
    coaVersionRequired: 'Selecione o plano de contas do livro contábil.',
    correctionReasonRequired: 'Informe o motivo da correção do identificador.',
    referenceLoadError: 'Não foi possível carregar países e calendários.',
    fiscalConfigIncomplete:
      'Preencha os campos obrigatórios de Regime & Alíquotas ou limpe a seção antes de salvar.',
    fiscalConfigSaveError: 'Erro ao salvar configurações fiscais.',
    bookNotFoundAfterCreate: 'A entidade foi criada, mas o livro contábil não foi encontrado.',
    partialProgressRetryNote:
      'A entidade já foi criada. Ao tentar novamente, apenas as etapas pendentes serão repetidas.',
    coaSetup: {
      COA_CHOICE_REQUIRED: 'Escolha como o plano de contas será provisionado.',
      COA_VERSION_DETAILS_REQUIRED: 'Número e nome da versão do plano de contas são obrigatórios.',
      COA_EXISTING_VERSION_REQUIRED: 'Selecione uma versão publicada existente.',
      COA_SOURCE_VERSION_REQUIRED: 'Selecione a versão de origem para clonagem.',
    },
    fxPolicy: {
      FX_POLICY_NAME_REQUIRED: 'Informe um nome para a política de câmbio.',
    },
  },
};

export const entitiesEn = {
  title: 'Entities',
  subtitle: 'Manage companies in your tenant',
  loading: 'Loading entities...',
  noResults: 'No entities found.',
  createButton: 'New entity',
  searchPlaceholder: 'Search entities…',
  form: {
    create: 'New entity',
    edit: 'Edit Entity',
    missingFields: 'Missing: {{fields}}',
    basicInfo: {
      title: 'Basic Information',
      description: 'Company registration data',
      country: 'Country of domicile',
      countryPlaceholder: 'Select a country',
      identifierLabels: {
        CNPJ: 'CNPJ',
        RFC: 'RFC',
        EIN: 'EIN',
        VAT: 'VAT identification',
      },
      identifierPlaceholders: {
        CNPJ: '00.000.000/0000-00',
        RFC: 'AAA000000AAA',
        EIN: '00-0000000',
        VAT: 'National tax identifier',
      },
      correctionReason: 'Correction reason',
      correctionReasonPlaceholder: 'State the documentary source for this correction',
      name: 'Name',
      namePlaceholder: 'Company name',
      legalName: 'Legal name',
      optional: 'optional',
      lockedAtCreation: 'Set at creation',
      tradeName: 'Trade name',
      tradeNamePlaceholder: 'Trade name',
      cnpj: 'CNPJ',
      cnpjPlaceholder: '00.000.000/0000-00',
      stateRegistration: 'State registration',
      stateRegistrationPlaceholder: 'Exempt or the IE number',
      municipalRegistration: 'Municipal registration',
      municipalRegistrationPlaceholder: 'The IM number',
      addressStreet: 'Street',
      addressStreetPlaceholder: 'Example Street',
      addressNumber: 'Number',
      addressNumberPlaceholder: '100',
      addressDistrict: 'District',
      addressDistrictPlaceholder: 'Downtown',
      addressCity: 'City',
      addressCityPlaceholder: 'Sao Paulo',
      addressState: 'State',
      addressStatePlaceholder: 'SP',
      addressPostalCode: 'Postal code',
      addressPostalCodePlaceholder: '00000-000',
      addressCodigoMunicipio: 'Municipality code (IBGE)',
      addressCodigoMunicipioPlaceholder: '0000000',
      addressCodigoMunicipioSearch: 'Search the municipality',
      addressCodigoIbgeCepHint: 'Fill in CEP to look up',
      addressCodigoUf: 'State code (IBGE)',
      addressCodigoUfPlaceholder: '00',
      groups: {
        identification: {
          title: 'Identification',
          subtitle: 'Who the company is: country of domicile, tax ID and names.',
        },
        registrations: {
          title: 'Registrations',
          subtitle: 'Tax registrations and the IBGE codes of the municipality and the state.',
        },
        address: {
          title: 'Address',
          subtitle: 'Where the company is established.',
        },
      },
      serpro: {
        loading: 'Consulting SERPRO...',
        genericError: 'Error consulting SERPRO',
        invalidCnpj: 'Invalid CNPJ',
        notFound: 'CNPJ not found in SERPRO',
      },
      focusCep: {
        autofillSuccess: 'Address auto-filled from postal code.',
        notFound: 'Postal code not found.',
        lookupError: 'Error looking up postal code.',
      },
    },
    taxpayerIdentity: {
      title: 'Federal taxpayer identity',
      description:
        'Set head office or branch from its legal role and effective period. Establishment number 0001 does not define the head office.',
      ownerReview:
        'Review the root, role, and effective dates with the tax owner before finishing.',
      cnpjRoot: 'CNPJ root',
      role: 'Role',
      rolePlaceholder: 'Choose head office or branch',
      roles: { HEAD_OFFICE: 'Head office', BRANCH: 'Branch' },
      validFrom: 'Valid from',
      validTo: 'Valid through (optional)',
      validFromRequired: 'Enter the start date for the federal taxpayer membership.',
      errors: {
        TAXPAYER_CNPJ_INVALID: 'The CNPJ is invalid.',
        TAXPAYER_CNPJ_ROOT_INVALID:
          'The CNPJ root must have exactly eight alphanumeric characters.',
        TAXPAYER_ENTITY_NOT_FOUND: 'The entity was not found. Refresh and try again.',
        TAXPAYER_ENTITY_CNPJ_REQUIRED:
          'Enter the entity CNPJ before defining its head-office or branch role.',
        TAXPAYER_ENTITY_CNPJ_CONFLICT:
          'The entity CNPJ conflicts with its primary tax identifier. Correct it first.',
        TAXPAYER_NOT_FOUND: 'The federal taxpayer was not found. Refresh and try again.',
        TAXPAYER_CNPJ_ROOT_MISMATCH: 'Head office and branches must share one CNPJ root.',
        TAXPAYER_MEMBERSHIP_DATE_INVALID: 'The end date must be on or after the start date.',
        TAXPAYER_MEMBERSHIP_OVERLAP:
          'The entity already belongs to a federal taxpayer in this period.',
        TAXPAYER_MULTIPLE_HEAD_OFFICES:
          'This federal taxpayer already has a head office in the selected period.',
        TAXPAYER_SUCCESSION_SAME_DAY:
          'Head-office succession must start after the current head office membership begins. Enter a later date.',
        TAXPAYER_HEAD_OFFICE_REQUIRED:
          'Define exactly one active head office for the assessment period.',
        TAXPAYER_COMPANY_TAX_REGIME_MISMATCH:
          'Head office and branches must use the same company tax regime.',
        TAXPAYER_PIS_COFINS_REGIME_MISMATCH:
          'Head office and branches must use the same PIS/COFINS regime.',
        TAXPAYER_APPROVED_ASSESSMENT_LOCKED:
          'An approved assessment uses this membership. Reopen or replace it before changing the period.',
        TAXPAYER_EXPLICIT_ROLES_REQUIRED:
          'This CNPJ root already belongs to another entity or federal taxpayer. Explicitly choose head office or branch.',
        TAXPAYER_FISCAL_MEMBERSHIP_CHANGED_RETRY:
          'The head office and branch membership changed while saving. Refresh and try again.',
      },
      succession: {
        title: 'Replace the active head office?',
        description:
          'The current head office will end that role on the prior day and become a branch on the selected date. This affects future federal assessments.',
        confirm: 'Replace head office',
        cancel: 'Keep current head office',
      },
    },
    regimeAliquotas: {
      title: 'Regime & Rates',
      description: 'Configure fiscal parameters for this entity.',
    },
    historicalLedger: {
      title: 'Imported history end date',
      description:
        'Use this date when the entity came from another system and its ledger was imported. It says up to when the books are already done.',
      effects: {
        title: 'What this date does',
        reconciled:
          'Bank movements up to this date are reconciled as "Already booked in the imported history". They create no payables, receivables or journal entries, because the imported ledger already holds them.',
        normalAfter: 'Movements after this date follow the normal flow.',
        checks:
          'To save, every month up to the date needs 3 checks at OK: ledger verified, bank = statement (to the cent) and month closed.',
        moveBack:
          'You can move the date forward later. To move it back, first undo the "Already booked in the imported history" reconciliations that would fall outside it.',
      },
      empty: {
        title: 'Nothing to set up for this entity',
        body: 'This entity has no verified ledger imported from another system. Without one, the date does not apply: every bank movement follows the normal flow.',
      },
      dateLabel: 'History end date',
      stored: 'Saved date: {{date}}',
      notSet: 'No date saved.',
      suggestion: 'Suggestion: {{date}} (latest verified import).',
      useSuggestion: 'Use suggestion',
      laterVerified: 'There is a verified import up to {{date}}. Update the date.',
      nativeAccrualWarning:
        '{{count}} native payable/receivable accrual entries dated on or before {{date}} may duplicate what the imported ledger already holds.',
      loading: 'Computing checks...',
      loadError: 'Could not load the checks.',
      noMonths: 'No verified import for this entity.',
      save: 'Save',
      saveReason: {
        noDate: 'Pick a date to save.',
        notGreen: 'Save is available once every month in the table is at OK.',
        alreadySaved: 'This date is already saved.',
      },
      saved: 'History end date saved.',
      checking: 'Checking {{date}}...',
      manageRequired: 'You need the manage-accounting permission to save this date.',
      tieOutStale:
        'A bank account with movements up to {{date}} was not in the saved tie-out. Save the date again to include it; until then, its movements cannot be marked as already booked.',
      openingCutoffRow: 'Opening balances ({{date}})',
      failedRows: {
        title: 'The server refused {{date}}. Checks that did not pass:',
        month: 'Month',
        account: 'Account',
        check: 'Check',
        gl: 'Ledger',
        statement: 'Statement',
        difference: 'Difference',
      },
      checks: {
        RAZAO_VERIFIED: 'Ledger verified',
        BANK_TIE_OUT: 'Bank = statement',
        MONTH_CLOSED: 'Month closed',
      },
      table: {
        month: 'Month',
        razaoVerified: 'Ledger verified',
        bankTieOut: 'Bank = statement',
        monthClosed: 'Month closed',
        account: 'Account',
        gl: 'Ledger',
        statement: 'Statement',
      },
      status: {
        GREEN: 'OK',
        RED: 'Pending',
        GREY: 'Out of scope',
        NOT_APPLICABLE: 'Not applicable',
      },
      reasons: {
        TIED_OUT: 'Ties out',
        STATEMENT_BALANCE_MISSING: 'No statement balance',
        AMOUNT_MISMATCH: 'Ledger differs from statement',
        PROOF_UNAVAILABLE: 'Balance proof unavailable',
        ACCOUNT_NOT_VISIBLE: 'No access to account',
        OUT_OF_SCOPE: 'No movement or balance',
        PROOF_FAILED: 'Balance proof failed',
        FOREIGN_CURRENCY: 'Foreign-currency account',
      },
      errors: {
        ENTITY_HISTORICAL_LEDGER_END_DATE_CHECKS_FAILED:
          'Could not save: {{count}} check(s) did not pass. Fix the red months.',
        ENTITY_HISTORICAL_LEDGER_END_DATE_MOVE_BACK_BLOCKED:
          'Cannot move the date back or clear it: {{count}} "Already booked in the imported history" reconciliation(s) would fall outside it. Undo them first.',
        ENTITY_HISTORICAL_LEDGER_END_DATE_NOT_VERIFIED_MONTH_END:
          'The date must be the end of a month with a verified import: {{dates}}.',
        ENTITY_HISTORICAL_LEDGER_BOOK_NOT_FOUND:
          'This entity has no accounting book. Set up accounting in Settings → Accounting & Tax → Entities → edit the entity.',
        ENTITY_HISTORICAL_LEDGER_INVALID_DATE: 'Invalid date. Use the dd/mm/yyyy format.',
        ENTITY_STATEMENT_BALANCE_MONTH_NOT_ENDED:
          'The month has not ended yet. You can type its statement balance from {{date}}.',
        ENTITY_STATEMENT_BALANCE_MONTH_LOCKED:
          'Locked: this month is already saved in "Imported history end date" (up to {{date}}). Move that date back to change the typed balance.',
        ENTITY_STATEMENT_BALANCE_PROVIDER_BALANCE_EXISTS:
          'The bank already reports a balance for this account at the month end, so a typed balance is not accepted.',
        ENTITY_STATEMENT_BALANCE_RECON_MONTH_CLOSED:
          'This account-month is closed in reconciliation. Reopen it to change the typed balance.',
        ENTITY_STATEMENT_BALANCE_MONTH_NOT_IN_HISTORY:
          'This month is not part of the imported history, so its statement balance cannot be typed here.',
        ENTITY_STATEMENT_BALANCE_INVALID_AMOUNT:
          'Invalid amount. Enter the statement balance, for example 1,525.15.',
        ENTITY_STATEMENT_BALANCE_INVALID_MONTH: 'Invalid month.',
        generic: 'Could not save the history end date.',
      },
      declared: {
        inputLabel: 'Statement balance of {{account}} for {{month}}',
        save: 'Save',
        saveFor: 'Save the statement balance of {{account}} for {{month}}',
        clear: 'Clear',
        clearFor: 'Clear the typed balance of {{account}} for {{month}}',
        negativeFor: 'Negative balance of {{account}} for {{month}}',
        negativeHint: 'Minus sign: the account is overdrawn',
        exactOnly:
          'This value has more decimal places than the field accepts and is shown exactly. Clear it to type another.',
        saved: 'Statement balance saved.',
        cleared: 'Typed balance removed.',
        typedBy: 'Typed by {{user}} on {{date}}',
        typedByUnknown: 'Typed on {{date}}',
        imported: 'imported: {{amount}}',
        importedAs: {
          DAILY_BALANCE: 'imported (daily balance): {{amount}}',
          LAST_TRANSACTION_BALANCE: 'imported (last transaction balance): {{amount}}',
        },
        sources: {
          USER_DECLARED: 'Typed',
          STATEMENT_CLOSING: 'Imported statement',
          DAILY_BALANCE: 'Daily balance',
          LAST_TRANSACTION_BALANCE: 'Last movement',
        },
        confirmClear: {
          title: 'Clear the typed balance?',
          description:
            'The typed balance of {{account}} for {{month}} will be removed. The month goes back to the imported balance, if there is one.',
          confirm: 'Clear',
        },
        locked: {
          MONTH_NOT_ENDED: 'Available from {{date}}',
          BEFORE_SAVED_END_DATE: 'Locked: month already saved in Imported history end date',
          PROVIDER_BALANCE_EXISTS: "The bank already reports this month's balance",
          SUPERSEDED: 'Typed balance ignored: the bank reports a balance',
          RECON_MONTH_CLOSED: 'Month closed in reconciliation: reopen it to change',
          MONTH_NOT_IN_HISTORY: 'This month is not part of the imported history',
        },
      },
    },
    accounting: {
      title: 'Initial accounting setup',
      description: 'Creates the statutory book and assigns its functional currency.',
      calendar: 'Fiscal calendar',
      calendarPlaceholder: 'Select a calendar',
      framework: 'Accounting framework',
      frameworkPlaceholder: 'Select an accounting framework',
      functionalCurrency: 'Functional currency',
      bookCode: 'Book code',
      bookName: 'Book name',
      chart: 'Chart of accounts',
      chartPlaceholder: 'Select a chart of accounts',
      chartNotNeededForMemo: 'Tax-basis (TAX_BASIS) books do not use a chart of accounts.',
      noPublishedCharts:
        'No published chart of accounts is available for this organization. Publish a chart of accounts in Settings before creating the entity.',
    },
    coaSetup: {
      title: 'Chart of accounts',
      description: "Choose how this book's active chart of accounts will be provisioned.",
      mode: 'Mode',
      modePlaceholder: 'Select a mode',
      modes: {
        CREATE_NEW: 'Create a new chart from scratch',
        USE_EXISTING: 'Use an existing published version',
        CLONE_EXISTING: 'Clone from an existing version',
      },
      loadingVersions: 'Loading versions...',
      existingVersion: 'Existing version',
      existingVersionPlaceholder: 'Select a published version',
      versionNumber: 'Version number',
      versionNumberPlaceholder: 'e.g. BR-V1',
      versionName: 'Version name',
      versionNamePlaceholder: 'e.g. Brazil Chart of Accounts',
      versionDescription: 'Description (optional)',
      versionDescriptionPlaceholder: 'Notes about this version',
      sourceVersion: 'Source version',
      sourceVersionPlaceholder: 'Select the version to clone',
    },
    fxPolicy: {
      title: 'FX policy',
      description: "Creates this book's FX policy with smart-default accounts.",
      name: 'Policy name',
      namePlaceholder: 'e.g. Brazil FX Policy',
      defaultsNote:
        'Unrealized FX gain/loss accounts will be resolved automatically from the active chart of accounts.',
      deferredForNewChart:
        'A brand-new, empty chart of accounts has no accounts yet to configure an FX policy against. Add the needed accounts and set up an FX policy afterward from Settings.',
    },
  },
  page: {
    listLabel: 'Entity list',
    searchLabel: 'Search entities',
    empty: 'No entities yet. Use “New entity” to create the first one.',
    listLoadError: 'Could not load the entity list.',
    loadError: 'Could not load the entity.',
    loadingDetails: 'Loading the entity…',
    tabsLabel: 'Entity sections',
    tabs: {
      basic: 'Basic information',
      regime: 'Regime & Rates',
      revenueTax: 'Revenue taxes',
      history: 'History',
      revenueTaxPending: 'setup pending',
    },
    regimeBrazilOnly: 'Tax regime and rates only apply to entities in Brazil.',
    revenueTaxBrazilOnly: 'Revenue taxes (PIS/COFINS) only apply to entities in Brazil.',
    tabReadOnly: 'Read only: you do not have permission to change this section.',
    revenueTaxSaveFirst:
      'There are unsaved regime and rate changes. Save them on the "{{tab}}" tab to update the taxes on revenue.',
    revenueTaxSaveToActivate: 'Save the changes on the "{{tab}}" tab to activate.',
    footer: {
      count_one: '{{count}} entity',
      count_other: '{{count}} entities',
      discard: 'Discard',
      save: 'Save changes',
      allSaved: 'All saved',
      unsaved_one: '{{count}} unsaved change',
      unsaved_other: '{{count}} unsaved changes',
      readOnly: 'Read only',
    },
    discardDialog: {
      title: 'Discard changes?',
      description: 'The unsaved changes to this entity will be lost.',
      confirm: 'Discard',
      cancel: 'Keep editing',
    },
  },
  detail: {
    entity: 'Entity',
    tradeName: 'Trade name',
    cnpj: 'CNPJ',
    group: 'Group',
  },
  common: {
    loading: 'Loading...',
    save: 'Save',
    saving: 'Saving…',
    retry: 'Retry',
    cancel: 'Cancel',
    edit: 'Edit',
    back: 'Back',
  },
  toasts: {
    created: 'Entity created successfully.',
    updated: 'Entity updated successfully.',
    updatedContinueRevenueTax: 'Entity updated. Continue the revenue tax setup below.',
    updatedContinueRevenueTaxTab: 'Entity updated. Now review the revenue taxes.',
    error: 'Error saving entity.',
    nameRequired: 'Name is required.',
    tradeNameRequired: 'Trade name is required.',
    cnpjRequired: 'Valid CNPJ is required.',
    primaryIdentifierRequired: 'Enter a valid tax identifier for the selected country.',
    accountingSetupRequired: 'Calendar, currency, and statutory book details are required.',
    coaVersionRequired: 'Select the chart of accounts for the statutory book.',
    correctionReasonRequired: 'Enter a reason for the identifier correction.',
    referenceLoadError: 'Countries and calendars could not be loaded.',
    fiscalConfigIncomplete:
      'Fill in the required Regime & Rates fields or clear the section before saving.',
    fiscalConfigSaveError: 'Error saving fiscal settings.',
    bookNotFoundAfterCreate: 'The entity was created, but its accounting book could not be found.',
    partialProgressRetryNote:
      'The entity was already created. Retrying will only repeat the steps that are still pending.',
    coaSetup: {
      COA_CHOICE_REQUIRED: 'Choose how the chart of accounts will be provisioned.',
      COA_VERSION_DETAILS_REQUIRED: 'Chart of accounts version number and name are required.',
      COA_EXISTING_VERSION_REQUIRED: 'Select an existing published version.',
      COA_SOURCE_VERSION_REQUIRED: 'Select the source version to clone from.',
    },
    fxPolicy: {
      FX_POLICY_NAME_REQUIRED: 'Enter a name for the FX policy.',
    },
  },
};
